/**
 * Reusable component for editing quesitons and answers
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as answerActions from '../../answer/answerActions';
import * as questionActions from '../questionActions';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Modal from '../../../global/components/modals/Modal.js.jsx';
import VideoPlayer from "../../../global/components/helpers/VideoPlayer.js.jsx";
import {
  CheckboxInput
  , NumberInput
  , RadioInput
  , SelectFromArray
  , SelectFromObject
  , TextInput
  , CdnPathInput
} from '../../../global/components/forms';

import VideoTrackListItem from '../../scene/components/VideoTrackListItem.js.jsx'

// import module components
import AdminAnswer from '../../answer/components/AdminAnswer.js.jsx';

// import utilities
import filterUtils from "../../../global/utils/filterUtils.js";
import videoUtils from "../../../global/utils/videoUtils.js";

// import question css modules
import questionStyles from '../questionModuleStyles.css';

class QuestionEditor extends Base {
  constructor(props) {
    super(props);
    this.state = {
      answerId: null
      , isEditingAnswer: false
      , isEditingQuestion: false
      , newAnswer: _.cloneDeep(this.props.defaultAnswer)
      , newQuestion: _.cloneDeep(this.props.question)
      , selectedAnswer: null
      , showConfirmDeleteAnswerModal: false
      , showConfirmDeleteQuestionModal: false
      , showNewAnswer: false
    }
    this._bind(
      '_addTrack'
      , '_cancelEditAnswer'
      , '_cancelEditQuestion'
      , '_deleteTrack'
      , '_handleCreateNewAnswer'
      , '_handleDeleteAnswer'
      , '_handleFormChange'
      , '_handleTrackFormChange'
      , '_handleUpdateAnswer'
      , '_handleUpdateQuestion'
      , '_openAnswerModal'
      , '_openDeleteAnswerModal'
    )
  }

  componentDidMount() {
    const { dispatch, question } = this.props;
    dispatch(answerActions.fetchListIfNeeded('_question', question._id));
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, question } = nextProps;
    dispatch(answerActions.fetchListIfNeeded('_question', question._id));
  }

  _cancelEditQuestion() {
    this.setState({
      isEditingQuestion: false
      , newAnswer: _.cloneDeep(this.props.defaultAnswer)
      , newQuestion: _.cloneDeep(this.props.question)
    })
  }

  _openAnswerModal(answer) {
    this.setState({
      isEditingAnswer: true
      , selectedAnswer: _.cloneDeep(answer)
    })
  }

  _openDeleteAnswerModal(answerId) {
    this.setState({
      answerId
      , showConfirmDeleteAnswerModal: true
    })
  }

  _cancelEditAnswer() {
    this.setState({
      isEditingAnswer: false
      , selectedAnswer: null
    })
  }

  _handleCreateNewAnswer() {
    const { defaultAnswer, dispatch, question } = this.props;
    let newAnswer = this.state.newAnswer
    newAnswer._question = question._id;
    newAnswer._evaluation = question._evaluation;
    newAnswer._contentModule = question._contentModule;
    dispatch(answerActions.sendCreateAnswer(newAnswer)).then((action) => {
      this.setState({
        newAnswer: _.cloneDeep(defaultAnswer)
      })
      dispatch(answerActions.invalidateList('_question', question._id));
    });
  }

  _handleFormChange(e) {
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    this.setState(newState);
  }

  _handleDeleteAnswer() {
    const { dispatch, question } = this.props;
    // dispatch(answerActions.invalidateList('_quesiton', question._id));

    dispatch(answerActions.sendDelete(this.state.answerId)).then((action) => {
      dispatch(answerActions.invalidateList('_quesiton', question._id));
      this.setState({
        answerId: null
        , showConfirmDeleteAnswerModal: false
      })
    })
  }

  _handleUpdateQuestion() {
    const { dispatch, question } = this.props;
    dispatch(questionActions.sendUpdateQuestion(this.state.newQuestion)).then((action) => {
      if(action.success) {
        console.log('success');
        dispatch(answerActions.invalidateList('_question', question._id));
        this._cancelEditQuestion();
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  _handleUpdateAnswer() {
    const { dispatch, question } = this.props;
    dispatch(answerActions.sendUpdateAnswer(this.state.selectedAnswer)).then((action) => {
      if(action.success) {
        console.log('success');
        dispatch(answerActions.invalidateList('_question', question._id));
        this._cancelEditAnswer();
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  _addTrack(videoType) {
    let currentTrackList;
    
    if(videoType == 'question') {
      currentTrackList = this.state.newQuestion.tracks
    } else {
      currentTrackList = this.state.selectedAnswer.tracks || [];
    }
    currentTrackList.push({ file: '', label: '' });
    this._handleFormChange({
      target: {
        name: videoType == 'question' ? 'newQuestion.tracks' : 'selectedAnswer.tracks'
        , value: currentTrackList
      }
    });
  }

  _deleteTrack(index, videoType) {
    let nextTrackList;
    if(videoType == 'question') {
      nextTrackList = this.state.newQuestion.tracks
    } else {
      nextTrackList = this.state.selectedAnswer.tracks
    }
    nextTrackList.splice(index, 1);
    this._handleFormChange({
      target: {
        name: videoType == 'question' ? 'newQuestion.tracks' : 'selectedAnswer.tracks'
        , value: nextTrackList
      }
    });
  }

  _handleTrackFormChange(e, index, videoType) {
    let nextTrackList;
    if(videoType == 'question') {
      nextTrackList = this.state.newQuestion.tracks
    } else {
      nextTrackList = this.state.selectedAnswer.tracks
    }
    if(e.name && e.value) {
      nextTrackList[index][e.name] = e.value;
    } else {
      nextTrackList[index][e.target.name] = e.target.value;
    }
    this._handleFormChange({
      target: {
        name: videoType == 'question' ? 'newQuestion.tracks' : 'selectedAnswer.tracks'
        , value: nextTrackList
      }
    });
  }

  render() {
    const {
      answerList
      , answerMap
      , defaultAnswer
      , handleDelete
      , question
      , questionNumber
      , sortedAnswers
      , trackingMetrics
    } = this.props;
    const {
      isEditingAnswer
      , isEditingQuestion
      , newAnswer
      , newQuestion
      , selectedAnswer
      , showNewAnswer
    } = this.state;

    let answerTypeText = "This question should have a single correct answer";
    if(question.answerType === 'multiple') {
      answerTypeText = "This question has multiple correct answers";
    } else if(question.answerType === 'boolean') {
      answerTypeText = "This question is true/false";
    } else if(question.answerType === 'freetext') {
      answerTypeText = "The answer for this question is an open ended free text response";
    }

    if(!question) {
      return null;
    } else {

      return (
        <div styleName="question-editor">

          <div styleName="-preview">
            <div styleName="-content" className="question-content">
              {questionNumber}. {question.content}
              <small styleName="-edit-question-link" className="action-link" onClick={() => this.setState({isEditingQuestion: true})}> &mdash; <em> Edit question </em></small>
              <small styleName="-edit-question-link" className="action-link -danger" onClick={() => this.setState({showConfirmDeleteQuestionModal: true})}> <em> Delete </em></small>
            </div>
            <small><em>{answerTypeText}</em></small>
            <div styleName="-answers">
              {sortedAnswers.map((answer, i) =>
                !answer ?
                  null
                :
                  <AdminAnswer
                    answer={answer}
                    handleDelete={this._openDeleteAnswerModal}
                    key={answer._id + i}
                    openModal={this._openAnswerModal}
                    type={question.answerType}
                  />
              )}
            </div>

            <div styleName="-new-answer">
              { showNewAnswer ?
                <div styleName="-new-answer-form">
                  <div className="yt-row with-gutters center-vert">
                    <div className="yt-col full s_40 m_50">
                      <TextInput
                        change={this._handleFormChange}
                        label="New answer content"
                        name="newAnswer.content"
                        value={newAnswer.content}
                      />
                    </div>
                    <div className="yt-col full s_20">
                      <NumberInput
                        change={this._handleFormChange}
                        label="Order"
                        name="newAnswer.orderWeight"
                        value={newAnswer.orderWeight}
                      />
                    </div>
                    <div className="yt-col full s_40 m_30">
                      <CheckboxInput
                        change={this._handleFormChange}
                        checked={newAnswer.correct}
                        label="Correct answer"
                        name="newAnswer.correct"
                        value={newAnswer.correct}
                      />
                    </div>
                  </div>
                  <div className="yt-row right">
                    <button className="yt-btn x-small link" onClick={() => this.setState({showNewAnswer: false, newAnswer: _.cloneDeep(defaultAnswer)})}>Cancel </button>
                    <button className="yt-btn x-small success" onClick={this._handleCreateNewAnswer}>Add answer</button>
                  </div>
                </div>
                : question.answerType !== 'boolean' && question.answerType !== 'freetext' ?
                <div styleName="-prompt">
                  <button className="yt-btn x-small link success" onClick={() => this.setState({showNewAnswer: true})}><i className="fa fa-plus"/> New answer</button>
                </div>
                :
                null
              }
            </div>
          </div>
          <Modal
            cardSize='large'
            closeAction={this._cancelEditQuestion}
            closeText="Cancel changes"
            confirmAction={this._handleUpdateQuestion}
            confirmText="Update question"
            disableConfirm={_.isEqual(newQuestion, question)}
            isOpen={isEditingQuestion}
            modalHeader={`Edit Question (ID = ${newQuestion._id})`}
            showButtons={true}
          >
            <div styleName="-question-form">
              <h3>Question Options</h3>
              <div className="yt-col full s_60">
                <TextInput
                  change={this._handleFormChange}
                  label="Content"
                  name="newQuestion.content"
                  rows="1"
                  value={newQuestion.content}
                />
                <SelectFromArray
                  capitalize={false}
                  change={this._handleFormChange}
                  items={trackingMetrics}
                  label="Tracking Metric"
                  name='newQuestion.metric'
                  value={newQuestion.metric}
                />
                <CdnPathInput
                  change={this._handleFormChange}
                  label="VideoPlayer URL"
                  name="newQuestion.videoPath"
                  required={false}
                  validate={false}
                  value={newQuestion.videoPath}
                />

                <CdnPathInput
                  change={this._handleFormChange}
                  label="Poster URL"
                  name="newQuestion.posterPath"
                  required={false}
                  validate={false}
                  value={newQuestion.posterPath}
                />
              </div>
              <div className="input-group">
                <label>Subtitle Tracks</label>
                <div className="-subtitle-tracks">
                  {newQuestion.tracks ? newQuestion.tracks.map((track, i) =>
                    <VideoTrackListItem
                      deleteTrack={this._deleteTrack}
                      handleTrackFormChange={this._handleTrackFormChange}
                      index={i}
                      key={i}
                      track={track}
                      // NOTE: formType exists in VideoTrackListItem, but wasn't being used. I am using it to keep track of which video the subtitles belong to.
                      // I'm not sure if we should change the name to something more fitting.
                      formType='question'
                    />
                  )
                  :
                    null
                  }
                </div>
                <button type="button" className="yt-btn x-small link success" onClick={() => this._addTrack('question')} style={{marginRight:20}}>+ Add track file</button>
              </div>
              <br/>
              <div className="yt-col full s_50 ">
                <SelectFromObject
                  change={this._handleFormChange}
                  display={'name'}
                  filterable={true}
                  label="Answer type"
                  name="newQuestion.answerType"
                  objects={[
                    {name:'Single correct answer (radios)', type: 'single'}
                    , {name:'Multiple correct answers (checkboxes)', type:'multiple'}
                    // , {name:'Free text', type:'freetext'} //- punting for now
                  ]}
                  selected={newQuestion.answerType}
                  value={'type'}
                />
                { newQuestion.answerType === 'boolean' ?
                  <RadioInput
                    label="The correct answer is"
                    options={[
                      {val: 'true', display: 'True'},
                      {val: 'false', display: 'False'},
                    ]}
                    name="newQuestion.correctBoolean"
                    value={newQuestion.correctBoolean}
                    change={this._handleFormChange}
                    inLine={false}
                  />
                  :
                  null
                }
              </div>
              <div className="yt-col full s_20 ">
                <NumberInput
                  change={this._handleFormChange}
                  label="Question orderWeight"
                  name="newQuestion.orderWeight"
                  step="1"
                  min="0"
                  value={newQuestion.orderWeight}
                />
              </div>
              <CheckboxInput
                change={this._handleFormChange}
                checked={newQuestion.randomizeAnswerOrder}
                label="Force randomized answer order?"
                name="newQuestion.randomizeAnswerOrder"
                value={newQuestion.randomizeAnswerOrder}
              />
            </div>
          </Modal>

          <Modal
            cardSize='large'
            closeAction={this._cancelEditAnswer}
            closeText="Cancel changes"
            confirmAction={this._handleUpdateAnswer}
            confirmText="Update answer"
            disableConfirm={selectedAnswer ? _.isEqual(selectedAnswer, answerMap[selectedAnswer._id]) : false}
            isOpen={isEditingAnswer}
            modalHeader="Edit Answer"
            showButtons={true}
          >
            { selectedAnswer ?
              <div>
                <div className="yt-col full s_40 m_50">
                  <TextInput
                    change={this._handleFormChange}
                    label="Answer content"
                    name="selectedAnswer.content"
                    value={selectedAnswer.content}
                  />
                  <CdnPathInput
                    change={this._handleFormChange}
                    label="VideoPlayer URL"
                    name="selectedAnswer.videoPath"
                    required={false}
                    validate={false}
                    value={selectedAnswer.videoPath}
                  />
                  <CdnPathInput
                    change={this._handleFormChange}
                    label="Poster URL"
                    name="selectedAnswer.posterPath"
                    required={false}
                    validate={false}
                    value={selectedAnswer.posterPath}
                  />
                </div>
                <div className="input-group">
                <label>Subtitle Tracks</label>
                <div className="-subtitle-tracks">
                  {selectedAnswer.tracks ? selectedAnswer.tracks.map((track, i) =>
                    <VideoTrackListItem
                      deleteTrack={this._deleteTrack}
                      handleTrackFormChange={this._handleTrackFormChange}
                      index={i}
                      key={i}
                      track={track}
                      formType='answer'
                    />
                  )
                  :
                    null
                  }
                </div>
                <button type="button" className="yt-btn x-small link success" onClick={() => this._addTrack('answer')} style={{marginRight:20}}>+ Add track file</button>
              </div>
                <div className="yt-col full s_20">
                  <NumberInput
                    change={this._handleFormChange}
                    label="Order"
                    name="selectedAnswer.orderWeight"
                    value={selectedAnswer.orderWeight}
                    />
                </div>
                <div className="yt-col full s_40 m_30">
                  <CheckboxInput
                    change={this._handleFormChange}
                    checked={selectedAnswer.correct}
                    label="Correct answer"
                    name="selectedAnswer.correct"
                    value={selectedAnswer.correct}
                    />
                </div>
              </div>
              :
              <div>loading...</div>
            }
          </Modal>
          <AlertModal
            alertMessage={<div><strong>STOP!</strong> Are you <em>sure</em> you want to delete this answer? This cannot be undone and will cause issues in analytics if anyone has taken this evaluation.</div> }
            alertTitle="Delete Answer"
            closeAction={() => this.setState({showConfirmDeleteAnswerModal: false})}
            confirmAction={this._handleDeleteAnswer}
            confirmText="Yes, Delete this answer"
            declineAction={() => this.setState({showConfirmDeleteAnswerModal: false})}
            declineText="Never mind"
            isOpen={this.state.showConfirmDeleteAnswerModal}
            type="danger"
          />
          <AlertModal
            alertMessage={<div><strong>STOP!</strong> Are you <em>sure</em> you want to delete this question <em>AND</em> all of it's answers? This cannot be undone and will cause issues in analytics if anyone has taken this evaluation.</div> }
            alertTitle="Delete Question"
            closeAction={() => this.setState({showConfirmDeleteQuestionModal: false})}
            confirmAction={() => handleDelete(question._id)}
            confirmText="Yes, Delete this question"
            declineAction={() => this.setState({showConfirmDeleteQuestionModal: false})}
            declineText="Never mind"
            isOpen={this.state.showConfirmDeleteQuestionModal}
            type="danger"
          />
        </div>
      )
    }
  }

}

QuestionEditor.propTypes = {
  dispatch: PropTypes.func.isRequired
  , handleDelete: PropTypes.func.isRequired
  , question: PropTypes.object.isRequired
  , questionNumber: PropTypes.number.isRequired
  , trackingMetrics: PropTypes.array
}

QuestionEditor.defaultProps = {
  trackingMetrics: []
}

const mapStoreToProps = (store, ownProps) => {
  /**
   * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
   * differentiated from the React component's internal state
   */

  let answerList = store.answer.util.getList('_question', ownProps.question._id);
  let sortedAnswers = [];
  if(answerList) {
    sortedAnswers = filterUtils.sortByOrderWeight(answerList);
  }

  return {
    answerList
    , answerMap: store.answer.byId
    , defaultAnswer: store.answer.defaultItem
    , sortedAnswers
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(QuestionEditor)
);



// WEBPACK FOOTER //
// modules/question/components/QuestionEditor.js.jsx